import { round } from "lodash";

export const defaultLocale = {
  name: "Swedish",
  lower: "swedish",
  short: "sv",
  country: "Sweden"
};

export const localeNameShort = defaultLocale.short;

export const dateFormat = "YYYY-MM-DD";

const create = (options?: Intl.DateTimeFormatOptions) => (date: Date | string) => {
  if (!date) {
    return null;
  }

  if (typeof date === "string") {
    date = new Date(date);
  }

  return new Intl.DateTimeFormat("sv", options).format(date);
};

export const toLocale = {
  weekday: create({ weekday: "long" }),
  time: create({
    minute: "2-digit",
    hour: "2-digit"
  }),
  shortDate: create({
    day: "2-digit",
    month: "2-digit"
  }),
  date: create(),
  dateTime: create({
    minute: "2-digit",
    hour: "2-digit",
    day: "2-digit",
    month: "2-digit",
    year: "numeric"
  }),
  sek: (v: number) =>
    new Intl.NumberFormat(defaultLocale.short, {
      style: "currency",
      currency: "SEK",
      minimumFractionDigits: 2
    }).format(v),
  sekWhole: (v: number) => `${round(v, 0)} kr.`,
  currencyDecimal: new Intl.NumberFormat(defaultLocale.short, {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format,
  currencyDecimalNumber: (v: number) => round(v, 2)
};

export function getLocaleMonths() {
  const format = new Intl.DateTimeFormat(defaultLocale.short, { month: "long" });

  const months = [];

  for (let month = 0; month < 12; month++) {
    const testDate = new Date(Date.UTC(2000, month, 1, 0, 0, 0));
    months.push(toUpperFirst(format.format(testDate)));
  }

  return months;
}

function toUpperFirst(str: string) {
  return str.substring(0, 1).toUpperCase() + str.substring(1);
}
